import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "more-info-products" }
const _hoisted_2 = { class: "more-info-products__form" }

import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


export default /*@__PURE__*/_defineComponent({
  __name: 'MoreInfoProducts.component',
  setup(__props) {

function redirectWhatsapp() {
    window.open('https://api.whatsapp.com/send?phone=51998247832', '_blank', 'noopener,noreferrer');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h3", null, "¿No encuentras el producto que buscas?", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("p", null, "Escribenos al whatsapp y te ayudaremos a encontrar el producto que buscas.", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", { onClick: redirectWhatsapp }, [
        _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faWhatsapp) }, null, 8, ["icon"]),
        _cache[0] || (_cache[0] = _createTextVNode(" Cotizar ", -1))
      ])
    ])
  ]))
}
}

})